import cx from "clsx";
import { PolicyDetailInfo } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";

import styles from "./index.module.scss";

import useFormattedPolicy from "@/modules/common-hooks/useFormattedPolicy";
import {
  formatInteger$Compact,
  formatInteger$Standard,
  formatLovelaceAmount$Compact,
  formatLovelaceAmount$Standard,
  formatPercentage$Compact,
  formatPercentage$Standard,
} from "@/modules/common-utils/format";
import { ImageViewer } from "@/modules/kreate-components/components/ImageViewer";
import PolicyTitleViewer from "@/modules/kreate-components/components/PolicyTitleViewer";
import UserDisplayNameViewerV2 from "@/modules/kreate-components/components/UserDisplayNameViewerV2";
import { getLinkToPagePolicy } from "@/modules/navigation/utils/getLinkTo";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  collection: PolicyDetailInfo | undefined | null;
};

export default function SectionCollectionOfTheDay({
  className,
  style,
  collection,
}: Props) {
  const { avatar, banner } = useFormattedPolicy(collection, {
    returnBanner: true,
  });

  return (
    <div className={cx(styles.container, className)} style={style}>
      <h2 className={styles.title}>{"Collection of the Day"}</h2>
      <Flex.Col className={styles.panelCollection}>
        <Link href={collection ? getLinkToPagePolicy(collection) : "#disabled"}>
          <Flex.Row className={styles.bannerContainer}>
            <ImageViewer
              value={banner}
              sizing={"fill"}
              style={{ objectFit: "cover" }}
              sizes="100vw"
            />
          </Flex.Row>
        </Link>
        <Flex.Col padding="32px 48px" className={styles.panelInfo} gap="16px">
          <Flex.Cell className={styles.collectionTitle}>
            <PolicyTitleViewer
              policyDetailInfo={collection}
              unstyled
              iconSize="0.5em"
            />
          </Flex.Cell>
          <Flex.Row gap="24px" flexWrap="wrap">
            <div className={styles.avatarViewerContainer}>
              <Link
                href={
                  collection ? getLinkToPagePolicy(collection) : "#disabled"
                }
              >
                <ImageViewer value={avatar} sizing={"fill"} sizes={"56px"} />
              </Link>
            </div>
            <hr className={styles.dashedVerticalDivider}></hr>
            <Flex.Col className={styles.labelledValue}>
              <div className={styles.label}>{"Artist"}</div>
              <div className={styles.value}>
                <UserDisplayNameViewerV2
                  user={collection?.populated?.userProfile}
                  unstyled
                />
              </div>
            </Flex.Col>
            <hr className={styles.dashedVerticalDivider}></hr>
            <Flex.Col className={styles.labelledValue}>
              <div className={styles.label}>{"Assets"}</div>
              <div
                className={styles.value}
                title={formatInteger$Standard(collection?.quantity)}
              >
                {formatInteger$Compact(collection?.quantity)}
              </div>
            </Flex.Col>
            <hr className={styles.dashedVerticalDivider}></hr>
            <Flex.Col className={styles.labelledValue}>
              <div className={styles.label}>{"Listed"}</div>
              <div
                className={styles.value}
                title={formatInteger$Standard(
                  collection?.totalNumListedEditions
                )}
              >
                {formatInteger$Compact(collection?.totalNumListedEditions)}
              </div>
            </Flex.Col>
            <hr className={styles.dashedVerticalDivider}></hr>
            <Flex.Col className={styles.labelledValue}>
              <div className={styles.label}>{"Total Volume"}</div>
              <div
                className={styles.value}
                title={formatLovelaceAmount$Standard(collection?.totalVolume)}
              >
                {formatLovelaceAmount$Compact(collection?.totalVolume)}
              </div>
            </Flex.Col>
            <hr className={styles.dashedVerticalDivider}></hr>
            <Flex.Col className={styles.labelledValue}>
              <div className={styles.label}>{"Royalty"}</div>
              <div
                className={styles.value}
                title={formatPercentage$Standard(collection?.royalty)}
              >
                {formatPercentage$Compact(collection?.royalty)}
              </div>
            </Flex.Col>
            <hr className={styles.dashedVerticalDivider}></hr>
            <Flex.Col className={styles.labelledValue}>
              <div className={styles.label}>{"Starting At"}</div>
              <div
                className={styles.value}
                title={formatLovelaceAmount$Standard(
                  collection?.floorPriceOnKreate
                )}
              >
                {formatLovelaceAmount$Compact(collection?.floorPriceOnKreate)}
              </div>
            </Flex.Col>
            {/* <hr className={styles.dashedVerticalDivider}></hr>
            <Flex.Col className={styles.labelledValue}>
              <div className={styles.label}>{"Best Offer"}</div>
              <div
                className={styles.value}
                title={formatLovelaceAmount$Standard(collection?.bestOffer)}
              >
                {formatLovelaceAmount$Compact(collection?.bestOffer)}
              </div>
            </Flex.Col> */}
          </Flex.Row>
        </Flex.Col>
      </Flex.Col>
    </div>
  );
}
